import { each } from 'vest';

import { LineMessageBlock } from '../types';

import { validationBuilder } from './validationBuilder';

type LineMessageValidation = {
  validateForm: (props: { messages: LineMessageBlock[] }) => void;
  validatePreview: (props: { messages: LineMessageBlock[]; prefix: string }) => void;
};

export const lineMessageValidation: LineMessageValidation = {
  validateForm: ({ messages }) => {
    each(messages, (message, idx) => {
      const { validatePlainText, validateRichMessage, validateImages, validateLineMessageButton } =
        validationBuilder(idx);

      if (message.type === 'PLAIN_TEXT') {
        validatePlainText(message);
      }

      if (message.type === 'RICH') {
        validateRichMessage(message);
      }

      if (message.type === 'IMAGES') {
        validateImages(message);
      }

      if (message.type === 'BUTTON') {
        validateLineMessageButton(message);
      }
    });
  },
  validatePreview: ({ messages, prefix }) => {
    each(messages, (message, idx) => {
      const { validateLineMessagePreviewButton } = validationBuilder(idx, prefix);

      if (message.type === 'BUTTON') {
        validateLineMessagePreviewButton(message);
      }
    });
  },
};
